const zh = {
  language: {
    zh: '简体中文',
    en: 'English'
  },
  userDetails: '用户详情',
  lastName: '姓氏',
  firstName: '名字',
  email: '邮箱',
  yourEmailBeenVerified: '您的邮箱尚未验证。',
  verifyEmail: '验证邮箱',
  paymentMethods: '支付方式',
  search: '搜索',
  clear: '清除',
  allOrders: '全部订单',
  upcoming: '待入住',
  completed: '已完成',
  cancelled: '已取消',
  yearN: '年',
  month: '月',
  day: '日',
  bedBreakfast: '含早',
  nonFefundable: '不可取消',
  creationDate: '预订日期：',
  confirmed: '已确认',
  bookingReference: '预订编码',
  viewDetails: '查看详情',
  pending: '待确认',
  unpaid: '待支付',
  back: '返回',
  yourBookingHasBeenCancelled: '您的订单已取消',
  bookingDetails: '订单详情',
  roomName: '客房',
  checkInTime: '入住时间',
  checkOutTime: '离店时间',
  travelDates: '入住总天数',
  roomNumber: '客房数',
  guest: '人数',
  guestName: '客人姓名',
  room: '房间',
  bedType: '床型',
  breakfast: '早餐',
  cancellationPolicy: '取消政策',
  specialRequests: '特殊要求',
  cancellationDateTime: '取消时间',
  priceDetails: '价格详情',
  onOurSite: '间房',
  avgNight: '每晚平均',
  taxesFees: '税费',
  totalPrice: '总价',
  paymentDetails: '支付和退款详情',
  paymentMethod: '支付类型',
  creditCardNumber: '信用卡号',
  paymentAmounts: '订单支付金额',
  cancellationCharges: '取消费用',
  refund: '退款金额',
  bookingConfirmationHasBeenSend: '我们已经收到您的预订请求，正在紧急联系酒店进行处理。我们会在有更新时通过电子邮件通知您。再次感谢您选择Roompai。',
  printVoucher: '打印行程单',
  contactGus: '联系客服',
  cancel: '取消订单',
  goingTo: '目的地/酒店名称',
  startIn: '开始日期',
  endOut: '结束日期',
  betweenRoom: '间客房',
  childrenAges: '儿童年龄',
  myFavorite: '我的收藏',
  seeAllPhotos: '查看全部图片',
  swimmingPool: '游泳池',
  freeWifi: '免费',
  freeShuttleBus: '免费机场班车',
  airConditioning: '空调',
  resaurants: '餐厅',
  seeallFacilities: '显示所有设施',
  whatNearby: '探索周边',
  minDrive: '车程',
  minWalk: '分钟',
  seeMoreDetails: '显示更多详情',
  facilities: '设施',
  overview: '概览',
  policies: '政策',
  freeBreakfast: '含早餐',
  freeCancellation: '限时取消',
  roomType: '房型',
  price: '价格',
  perRoomNight: '每晚',
  instantConfirmation: '立即确认',
  afterTax: '每晚含税价',
  book: '预订',
  onlyLast: '仅剩最后',
  showMore: '查看更多报价',
  opened: '开业',
  telephone: '电话',
  hotelAddress: '酒店位置',
  roomFeatures: '客房特色',
  bookingNotice: '订房须知',
  improtantInformation: '重要通知',
  cityNotice: '城市通知',
  childrenNotice: '儿童须知',
  pets: '宠物须知',
  ageRequirements: '年龄限制',
  checkInFrom: '入住办理起始时间',
  checkOutUntil: '退房办理截止时间',
  extraService: '额外服务',
  breakfastMoney: '早餐费',
  unlessRoomPrice: '若房费未含',
  restaurantsNumber: '餐厅数量',
  breakfastType: '早餐类型',
  openingHours: '营业时间',
  chargeOrDepositAboveWillBePaidHotel: '上述费用和押金由酒店在提供服务、办理入住或退房手续时收取。',
  amountAboveIsOnlyForYouReferenceFinalChargeByHotel: '上述金额仅供参考，具体以酒店实际收取数额为准',
  languageSpoken: '可用语言',
  internetAccess: '上网服务',
  waysToRelax: '休闲娱乐',
  dinDrinkSnack: '餐饮服务设施',
  transportService: '交通服务',
  forTheKids: '儿童设施',
  other: '其他设施',
  avaliableInAllRoom: '所有客房均提供',
  searchByProperty: '关键词搜索',
  propertyClass: '星级筛选',
  pricePerNight: '您的预算',
  filter: '筛选搜寻',
  bestMatch: '热门推荐',
  lowPriceFirst: '低价优先',
  highPropertyClass: '高星优先',
  leftAtThisPrice: '只剩',
  selectRoom: '选择客房',
  properties: '家酒店',
  propertyClass5: '五星',
  propertyClass4: '四星',
  propertyClass3: '三星',
  propertyClass2: '二星',
  lessThan: '低于',
  greaterThan: '高于',
  forgotPassword: '忘记密码',
  electronEmail: '电子邮箱',
  pleaseYourEmailInBox: '请在上方文本框内输入您的邮箱，',
  weSendYouLinkToAccessInstructions: '我们将向您发送相关链接以提供更多详细说明。',
  resetPassword: '重置密码',
  backToSignIn: '返回登录',
  signIn: '登录',
  linkToResetYoutPasswordSend: '我们已将重置密码的链接发送到',
  pleaseCheckYoutEmail: '请注意查看您的邮箱。',
  emailOrPasswordIncorrect: '电子邮箱地址或密码不正确',
  pleaseCheckThem: '请重新输入',
  password: '密码',
  createAccount: '注册',
  retypePassword: '确认密码',
  alreadyHaveAnAccount: '已有账户',
  bookingIsNowComplete: '预订成功',
  minutesTenYouBookingSendEmail: '预订确认函将在10分钟内发送至您的邮箱',
  backHome: '返回首页',
  manageMyBookings: '查看行程',
  justMiss: '下手晚了',
  justsoldOut: '已售罄',
  likeToCheckOtherPlans: '要不要查看下其他方案呢',
  bookCurAotherRoom: '查看本酒店其他房型',
  pendingMeanBookingnotCompleteYouBookingHotel: '订单待确认状态，指的是您预订了我们的最优价格产品。',
  limitedInventoriesAndBestPrice: '但是因为价格好库存少，所以售卖会比较火爆。',
  hotelAndYouWillReceiveFinalBookingStatusInbox: '我们会尽快为您查询价格和库存是否有效，10分钟内会为您更新订单状态。',
  bookingIsPendingWekeepYouInformedMinutes: '订单现在处于待确认状态，我们会在10分钟内帮您确认好订单的状态',
  bookingStatusWilBeSendToYourEmail: '订单状态通知同时会发送至您的邮箱',
  youBookingIsConfirming: '我们正在确认您的预订......',
  pleaseDoNotCLoseYourBrowserClickBackButton: '请不要关闭您的浏览器或点击返回按钮。',
  hoteInformation: '已选住宿',
  customerInformation: '客人信息',
  finalStep: '最后一步',
  minute: '分',
  bookingInformation: '预订信息',
  taxesAndServiceFees1: '此处的税款是指，roompai付给供应商（如酒店）的代缴税款。如需详细信息，请参阅我们的使用条款。作为向您提供预订服务的佣金，我们会收取一定的服务费。',
  createAccounts: '注册帐号',
  signingYourAccountBooking: '使用预填信息预订并随时管理您的订单！',
  please: '请在',
  second: '秒',
  fillUpAllPriceDiff: '内完成填写，以免房间被订完或者价格发生变化哦~',
  customerInformationDesc: '住客资料',
  pleaseEnglishLetter: '请使用英文字母',
  emailAddr: '电子邮箱地址',
  retypeEmail: '再次输入邮箱',
  pleaseEmailFieldsMatch: '请确保两次输入的邮箱地址一致',
  phoneNumber: '联系电话',
  pleaseValidPhone: '请输入有效的手机号码',
  nationality: '国籍',
  pleaseLastName: '请输入姓氏',
  pleaseTextEnglish: '请务必使用英文输入',
  pleaseFirstName: '请输入名字',
  haveSpecialRequests: '您还有什么特别要求？',
  specialRequestsAreGuaranteed: '特殊要求无法保证满足，但住宿将尽力为你提供所需。你始终可以在预订完成后提出特殊要求。',
  placeEnterTexteEnglish: '请使用英语填写您的请求。',
  buttonMeansYouAgree: '点击下方按钮，即表示您已阅读并接受',
  termsUse: '使用条款',
  and: '和',
  privacyPolicyO: '隐私声明',
  riskFree: '行程不确认？没问题。',
  propertyLocalTime: '星期一',
  noCancelFeeBefore: '前，都能免费取消',
  goFinalStep: '前往最后一步',
  pleaseEnterYourEmailOrYouMightMissBooking: '请务必输入邮箱，以免您无法收到行程单',
  pleaseValidEmail: '请输入有效的电子邮箱地址',
  reservationConfirmationEmail: '确保您能够收到预订确认邮件',
  priceInventoryDifferences: '内完成支付，以免房间被订完或者价格发生变化哦',
  encryptedSecure: '所有银行卡均经过加密处理，保护您的个人消息',
  mySavedCards: '已存信用卡',
  cardHolderName: '持卡人姓名',
  debitCardNumber: '借记卡号',
  expiryDate: '有效期至',
  cvv: '安全码',
  validCVV: '请输入有效的信用卡安全码',
  digitSecurityCode: '位数安全码',
  creditCard: '信用卡',
  bookNow: '完成预订',
  appearsOnTheCard: '请用英文字母输入与您信用卡上所示完全相同的持卡人姓名',
  validCardNumber: '请输入有效的卡号。',
  pleaseValidCardExpiry: '请选择有效的月份和年份',
  justMissO: '下手晚了哦',
  noInventory: '下手晚了哦，看看本酒店其他房型报价吧~',
  bookAotherRoom: '查看酒店其他房型',
  noRooms: '下手晚了哦，酒店已售空，看看其他酒店报价吧~',
  onlyStepLeft: '就差最后一步',
  roomOnly: '当前房型仅剩',
  roomLeft: '间房哦',
  continueBooking: '继续预订',
  confirmingPriceIng: '更新报价中',
  confirmingPrice: '更新报价',
  stillInterested: '还感兴趣吗',
  choiceTopSelling: '当前选择非常受欢迎哦',
  offerSoldOut: '最优报价已售空哦',
  updatePlan: '这边为您推荐涨价',
  higherPriceOfSameRoom: '的方案，',
  propertyIsRecommended: '房型不变，',
  wouldBookingIt: '是否继续预订呢?',
  myBookings: '我的行程',
  myAccount: '我的账户',
  customerServiceEmail: '客服联系邮箱',
  customerServicePhone: '客服联系电话',
  internationalCall: '仅限中国大陆拨打',
  domesticCall: '非中国大陆拨打',
  faq: '常见问答',
  privacyPolicy: '隐私政策',
  termsOfUse: '服务条款',
  aboutUs: '关于我们',
  contactUs: '联系我们',
  signOut: '退出',
  anyDestination: '城市、酒店住宿、景点或任何目的地',
  checkIn: '入住日期',
  checkOut: '退房日期',
  determine: '确定',
  bookingReferences: '订单编号',
  sendEmail: '发送邮件',
  bookingInfo: '订单信息',
  cancellation: '订单取消',
  modification: '订单修改',
  onlyBed: '不含早',
  refundable: '可取消',
  cancellationDate: '取消日期：',
  adult: '名大人',
  adults: '名大人',
  child: '名儿童',
  children: '名儿童',
  year: '岁',
  years: '多岁',
  breakfast2: '含早（2份）',
  dateFreeCancellation: '前可免费取消',
  filterBy: '筛选条件',
  limitedAvailability: '空房不多咯',
  bookingFailed: '预订失败',
  pleaseSelect: '请选择',
  setUp: '设置',
  languageAll: '语言',
  currency: '币种',
  youCanLoginAlterPrice: '登录后可找到更低特价！',
  allLanguages: '所有语言',
  allCurrency: '所有币种',
  name: '姓名',
  deletePay: '删除',
  night: '晚',
  between: '间',
  home: '首页',
  bookmin: '订',
  searchCriteria: '搜索条件',
  filters: '个筛选条件',
  deleteFilter: '删除',
  pleaseModifyYourSearchAndTryAgain: '无法找到任何符合您要求的结果，请更改搜索条件重新尝试。',
  sorryHaveNoRoomsAtPropertyOn: '抱歉，此酒店在所选日期内我们没有空房了，您可以：',
  changeYouDates: '搜索其他日期',
  haveNoBooking: '没有可查询的订单哦~ ',
  haveNoUpcomingBooking: '没有即将入住的订单哦~ ',
  haveNoCompletedCancelBooking: '没有已完成的订单哦~ ',
  haveNoCancelBooking: '没有已取消的订单哦~ ',
  noFavoriteHotelAddFavorite: '没有心仪的酒店? 快去收藏吧~',
  kilometre: '公里',
  rightAtThisPrice: '间',
  hotelDetailroomCount: '间',
  floor: '楼层',
  window: '窗户',
  scenery: '景观',
  area: '面积',
  maximum: '最大可入住人数',
  soldLeft: '在您出行期间我们没有空房了！试试',
  soldChangeDate: '更改日期',
  soldOr: '或者',
  soldOtherHotel: '查看别的酒店',
  soldRight: '吧~',
  VerifyEmailSuccess: '您的邮箱已验证成功！',
  sendEmailLeft: '我们将发送验证邮件至',
  sendEmailRight: '，请查看以完成验证。',
  checkinCheckout: '入住/离店办理',
  practicalInformation: '实用信息',
  userEmailVerifyFail: '邮箱验证错误！请进入邮箱重新验证。',
  yourBookingHasBeenConfirm: '您的订单已确认',
  orderNoConfirmLeft: '您的订单待确认，我们会在',
  orderNoConfirmRight: '内确认订单的状态。',
  orderPaymentLeft: '您的订单还没有支付哦 ~ 请在',
  orderPaymentRight: '内完成支付，以免房间被订完或者价格发生变化哦~',
  noBedBreakfast: '不含早',
  searchOtherHotelRoom: '搜索其他酒店住宿',
  windowed: '有窗',
  windowless: '无窗',
  good: '很舒适',
  awesome: '还不错',
  excellent: '超完美',
  exceptional: '惊艳了',
  veryClean: '干净整洁',
  excellentService: '服务贴心',
  fantasticFood: '食物美味',
  greatLocation: '位置很棒',
  comfortable: '十分舒适',
  warmStaff: '员工很温暖',
  niceSwimmingPool: '泳池很赞',
  niceKidsFacilities: '儿童玩乐设施赞',
  awesomeRestaurant: '餐厅很赞',
  fantasticGym: '健身房很赞',
  niceRoom: '房间特好',
  niceBar: '酒吧很棒',
  orderCancel: '取消订单',
  orderCancelReason: '取消订单原因：',
  selectCancelReason: '请选择取消订单原因',
  nowCancelRefund: '如果您现在取消，将会被收取',
  orderPrice: '订单金额',
  cancelPrice: '取消费用',
  refundPrice: '退款金额',
  close: '关闭',
  continueCancel: '继续取消',
  canNotCancelLeft: '因为现在订单处于不可取消状态，如果点击继续取消，会收取全部房费',
  canNotCancelRight: '作为罚金，不会产生任何退款。',
  isContinueCancel: '您还要继续取消吗？',
  goToPay: '去支付',
  yourCardOrAccountShouldReceiveRefundAmountLeft: '我们将在 24 小时内将您的',
  yourCardOrAccountShouldReceiveRefundAmountRight: '退款返还至您的银行。退款应该会在未来 10 个工作日内发放至您的帐户。如需了解更多信息，请联系您的银行。',
  orderCancelSuccess: '您的订单已成功取消！',
  yourCardOrAccountShouldReceiveRefundAmountRightTwo: '退款返还至您的银行，如订单已使用优惠券，优惠券已返还至您的账户，可在下次预定时使用。',
  contactBank: '如需了解更多信息，请联系您的银行。',
  freeCancellationBefore: '前申请取消，可退全款',
  taxesAndServiceFees: '此处的税款是指，roompai付给供应商（如酒店）的代缴税款。如需详细信息，请参阅我们的使用条款。作为向您提供预订服务的佣金，我们会收取一定的服务费。',
  pleaseValidEmailReservationConfirmationEmail: '请输入有效的电子邮箱地址, 确保您能够收到预订确认邮件',
  creditDebitCard: '信用卡/借记卡',
  creditBeditCardNumber: '借记卡/信用卡号',
  cancelForWaitPay: '预订失败！由于支付超时，您的订单已取消。如果还有需要，可以尝试再次预订。',
  cancelForWaitConfirm: '由于需求激增，您选择的房间已售空。目前订单已取消，可以尝试切换日期或者选择其他酒店继续预订。',
  orderWaitPaymentMess: '您的订单还没有支付哦 ~ 请尽快完成支付，以免房间被订完或者价格发生变化哦~',
  youBeenThisPageForeTooLongTime: '停留时间过长哦，请返回首页重新预订~',
  collectionPrefrences: '数据收集偏好',
  byClickAcceptAllowRoompaiMedia: '点击“接受”即代表，您允许Roompai.com和我们信赖的合作伙伴将您的个人信息用于分析和营销目的。分析数据处理可让我们了解您如何使用我们的网站，从而改善我们的网站和服务。营销数据处理帮助我们决定向您显示我们网站内外的产品类型，衡量我们的访客并允许您在社交媒体分享内容。',
  accept: '接受',
  decline: '拒绝',
  verifyEmailSendEmail: '我们已将邮箱验证的链接发送到',
  payDetail: '支付详情',
  amounts: '支付金额',
  orderCancelfaild: '您的订单取消失败！',
  contactCustomer: '如果您还想继续取消此订单，请联系我们客服。',
  contactEmail: '联系邮箱：',
  phoneNumberTwo: '联系电话：',
  noPrice: '暂无报价',
  youSureToDeleteTheCreditCard: '确定删除此信用卡信息吗？',
  accountBalanceSufficient: '账户余额充足',
  rooms: '房间',
  childAge: '儿童年龄',
  enterNameOfDestinationOrProperty: '请输入地名（目的地/酒店名称），以继续您的操作',
  onOurSites: '间房',
  persons: '人',
  logined: '已登录',
  noThisUser: '不是您的账户？点此',
  productType: '产品类型',
  score: '分',
  mailboxExists: '邮箱已存在',
  companyName: '北京驿思客信息技术有限公司',
  companyAddr: '北京市昌平区东小口镇天通苑三区8号楼1-2层全部一层',
  customerService: '客服联系方式',
  willRefundTime: '退款应该会在未来 10 个工作日内发放至您的账户。',
  nopic: '暂无图片',
  noCancelMsg: '因为现在订单处于不可取消状态，所以本单没有任何退款，如订单已使用优惠券，优惠券已返还至您的账户，可在下次预定时使用。',
  norefundContactUs: '如有问题，请联系我们的客服团队。',
  emailMsgLeft: '您的行程单将在3分钟内发送至',
  emailMsgRight: '。',
  networkErrorReschedule: '网络异常，请重新预订',
  noOrderFound: '没有查到这个订单。',
  paymentFailed: '支付失败，请重新预订',
  networkInterruptRetry: '网络中断，请重试',
  questionsPleaseContactUs: '如有问题，请联系我们客服团队。',
  ToBePaidStatusWaitPatiently: '订单现在处于待支付状态，您会在10分钟之内在我的行程页面查看到这个订单的支付状态，非常抱歉给您带来不便。',
  guests: '人',
  sortby: '排序',
  hoteListSold: '在您出行期间我们没有空房了！',
  hello: '您好！',
  mobileRiskFreeOne: '行程不确认？没问题。',
  mobileRiskFreeTwo: '',
  calendar: '日历',
  childNum: '儿童',
  peopleNum: '入住人数',
  rememberCard: '记住这张卡以便将来使用',
  floorNum: '楼',
  bookingReferenceNo: '预订编码：',
  hotelRelated: '酒店相关',
  ok: '确定',
  childNums: '儿童',
  lookRoom: '查看房型',
  nights: '晚',
  accommodates: '可住',
  people: '人',
  hotelLocation: '酒店位置',
  weHereToHelpYou: '客官，您的疑惑是我们最大的关切。',
  pleaseCheckAndSeeFindYourAnswers: '有什么问题，看看这里有没有您想要的答案～',
  floorTh: '楼',
  chineseYuan: '人民币',
  usDollar: '美元',
  sendVoucher: '发送行程单',
  accountBalance: '账户余额',
  payAccount: '支付账号',
  cancelReason: '取消原因',
  confirm: '确认',
  hotelPackagePrice: '我了解并接受套餐价格仅适用于同一位旅客同一次行程中与机票、租车、火车票或游轮相结合的预订。',
  bedTypeLikeMsg: '（床型方面的要求不保证一定可以满足。)',
  noRefundMsg: '如果变更或取消订单，您将无法获得退款。',
  refundNoShowMsg: '如出现No-Show （客人未按照预订日期入住），住宿也将收取全额费用。',
  refundMsg: '首晚没有入住，无法退款。如果第二晚入住，需要提前和酒店联系，否则后面的订单会被取消。',
  refundLocalTimeMsg: '以住宿当地时间为准。',
  putAway: '收起',
  noRefundTimeMsg: '后申请取消，您将无法获得退款。',
  noRefundNightMsg: '前申请取消，会产生相当于首晚（含税费）费用的罚金；',
  noRefundAmountOneMsg: '前申请取消，您将需要支付金额为',
  noRefundAmountTwoMsg: '的费用；',
  noRefundPercentOneMsg: '前申请取消，会产生',
  noRefundPercentTwoMsg: '订单费用的罚金；',
  beddingRequestsCannotBeGuaranteed: '床型方面的要求不保证一定可以满足。',
  rebateFefundable: '前可收费取消',
  bedTypePreference: '床型喜好',
  refundOtherMsg: '除此以外的费用:',
  noRefundDateOneMsg: '订单一经确认，入住日期',
  noRefundDateTwoMsg: '的费用（含税费）是无法退还的。',
  custometSourceMarket: '客源市场',
  allMarket: '所有市场',
  epsTermsAndCond: '供应商预订条款',
  agentTermsOfUse: '同业用户的补充条款',
  youNeedToKnow: '您需知道',
  fees: '费用',
  optionalExtras: '其他项目',
  specialCheckinInstructions: '特别入住说明',
  checkMinAge: '单独办理入住的最小年龄限制',
  transportationInformation: '交通信息',
  flightNumber: '航班号',
  date: '日期',
  departure: '起飞机场',
  arrival: '落地机场',
  reservationCode: '客票编号',
  epsPkgIconfirmCusInfo: '我确认：上述旅客已经预订出行交通（航班、游轮、租车或长途火车）。在于旅客的沟通过程中，客房预订将始终与交通预订进行捆绑报价，旅客不会得知客房预订的单价。旅客预订的出行交通信息如下：',
  planeTicket: '机票',
  validReservationCode: '请输入有效的客票编号',
  validflightNumber: '请输入有效的航班号',
  validDeparture: '请输入起飞机场三字码',
  validArrival: '请输入落地机场三字码',
  otaMsg: '所有价格禁止分销OTA和比价网站。',
  ticketInformation: '机票信息',
  resortFee: '度假费用',
  payNow: '现在付款',
  payableAtProperty: '到店付款',
  priceDetailMsg: '税费基于当前汇率，需以当地货币在住宿支付。',
  salesTax: '销售税',
  packageRate: '打包价格',
  propertyFee: '酒店费用',
  surcharges: '附加费用',
  mandatoryFee: '额外费用',
  mandatoryTax: '额外税款',
  taxTips: '此费用包括旅行服务提供商（即酒店、租车公司）和/或我们在您的预订中向税务机关所付税款的估计金额（包括但不限于销售、入住人数和增值税额）。此金额还可能包括以下任何金额：我们支付的度假费、清洁费和其他费用，以及/或者我们、酒店提供商和/或您的预订网站所收取作为部分服务佣金的费用（该费用因位置、金额和预订方式等因素而异）。如需了解详情，请查看条款和条件。',
  orderNoConfirm: '您的订单待确认。',
  electronicPayment: '电子支付',
  wechat: '微信',
  alipay: '支付宝',
  paypal: 'PayPal',
  theTotalAmountYouChanged: '您需要支付的预订总额为',
  youSelectPay: '您已经选择',
  youWillBeForwardedTo: '作为付款方式,您将被转到',
  websiteToProceedWithThisTransaction: '网站继续付款。',
  payMethod: '付款方式',
  qrCodePresale: '售前客服群',
  qrCodePostsale: '售后客服群',
  completeWeatchPay: '使用微信支付',
  useWechatToQecodePay: '使用微信扫描二维码,即可通过微信完成支付',
  step1: '第一步',
  step2: '第二步',
  accordingToPaymentResultSelect: '根据微信上的支付结果,成功则点击"支付成功",失败则点击"支付出错,继续支付"',
  paymentHadProblems: '支付出错,继续支付',
  paymentSpuccessful: '支付成功',
  hotelAndYouWillReceiveFinalBookingStatusInboxLeft: '我们会尽快为您查询价格和库存是否有效，',
  hotelAndYouWillReceiveFinalBookingStatusInboxRight: '分钟内会为您更新订单状态。',
  bookingIsPendingWekeepYouInformedMinutesLeft: '订单现在处于待确认状态，我们会在',
  bookingIsPendingWekeepYouInformedMinutesRight: '分钟内帮您确认好订单的状态。',
  payDisabled: '支付页已失效',
  payContact: '请联系我们客服处理。客服联系方式如下：',
  emailNotVerify: '您的邮箱未验证，请前往邮箱验证。',
  youBeenThisPageForeTooLongTimeToRefresh: '停留时间过长哦，请刷新页面~',
  paymentFailurePrompt: '您的预订失败是因为您的付款被拒绝。请验证您的帐户信息或尝试使用其他帐户完成付款。如果还有问题，请联系我们的客服处理，客服联系方式如下：',
  breakfastnum: '份',
  childPayTop: '您的订单有未支付的金额 ~ 请在 1天 内完成支付，以免修改失败哦~',
  childPayTip: '修改订单，有待支付金额！',
  childPayTopMobile: '请在 1天 内完成支付，以免修改失败哦~',
  childPayOverTimeTip: '修改订单，待支付超时！',
  bindEmail: '绑定邮箱',
  buttonBindNow: '立即绑定',
  unbindEmailMessage: '微信授权成功，请绑定邮箱',
  registerAndBindEmail: '注册并绑定邮箱',
  emailAlreadyBind: '无法绑定，该邮箱已与其他微信账户绑定。请换一个新邮箱重新绑定。',
  wechatAlreadyBind: '该微信已绑定邮箱，请直接登录',
  otherAuthorization: '其他登录方式',
  InvalidAuthorization: '无效的微信授权信息',
  additionalCharge: '行程差额',
  changeBindEmail: '换绑邮箱',
  wechatAccount: '微信帐号',
  wechatBindTime: '绑定时间',
  unBindWechat: '解除绑定',
  bindWechat: '绑定微信',
  mandaFee: '强制收费',
  currentLanguage: 'zh',
  confirmTitle: '确认操作',
  unBindWechatConfirmMessage: '确定要解除微信账户绑定吗？',
  unBindWechatSuccess: '解绑成功',
  userinfoNotFind: '未找到用户信息，请刷新后重试！',
  wechatNotBind: '该帐号未绑定微信授权',
  uniqueLoginMethod: '该帐号仅有此登录方式，不支持解绑',
  wechatLoginSuccess: '微信已登录',
  pageJumpPrompt: '页面跳转中',
  bindEmailPrompt: '如果已有其他邮箱账号，可点击绑定邮箱合并账号。如果没有，可以点击直接登录。',
  directLogin: '直接登录',
  bindEmailSuccess: '绑定成功',
  emailNotRegistered: '该邮箱地址没有创建过帐号。如想绑定，可以前往我的账户进行操作',
  loginSuccess: '登录成功',
  unbindWechatTitle: '解绑微信',
  unbindWechatDesc: '确定要解除微信账户绑定吗？',
  userId: '用户ID',
  bindWechatSuccess: '微信绑定成功',
  buttonCancel: '取消',
  buttonSave: '保存',
  buttonBindEmail: '绑定邮箱',
  buttonCheckEmail: '验证邮箱',
  buttonUnBindEmail: '解除绑定',
  lastNameError: '请输入有效的姓氏。',
  firstNameError: '请输入有效的名称。',
  emailError: '请输入有效的邮箱地址。',
  passWordError: '密码至少为6位字符',
  passWordTwoError: '两次输入的密码不一致。',
  mobileEmailCheckNotice: '验证邮件已发送至您的绑定邮箱，请查看并完成验证',
  unbindEmailSuccessNotice: '解除绑定成功',
  mobileBindEmailSuccessNotice: '绑定成功，但您的邮箱尚未验证，我们已发送验证邮件至绑定邮箱，请查看并完成验证',
  bindEmailIsset: '该邮箱已与其他账户绑定，请使用其他邮箱账户重新尝试',
  mobileCheckEmailVerifySuccess: '邮箱已验证',
  iconBound: '已绑定',
  iconNotVerified: '未验证',
  iconVerified: '已验证',
  iconNotBound: '未绑定',
  modifySuccess: '修改成功',
  modifyFail: '修改失败',
  unBindEmailConfirmMessage: '确定要解除邮箱账户绑定吗？',
  edit: '编辑',
  commission: '佣金',
  roompaiCommissionNotification: '此处的佣金是指，roompai向您提供预订服务而收取的费用，每一笔订单我们会收取一定的费用。',
  taxesFeesGoogle: '此处的税款是指，roompai付给供应商（如酒店）的代缴税款。如需详细信息，请参阅我们的使用条款。',
  taxesAndCharges: '税费及其他费用',
  notIncludedInTotal: '不包含在总价里',
  mandatoryChargeHotelCollected: '额外费用：酒店收取。',
  details: '详情',
  goPay: '完成预订',
  取消成功: '',
  cancelSuccess: '取消成功',
  cancelSuccessNotice: '如订单已使用优惠券，优惠券已返还至您的账户，可在下次预订时使用~',
  waitPay: '待支付',
  wechatNotice_website_mobile: '由于微信限制，网页端支付订单无法在手机端完成支付，请返回网页端继续支付，谢谢！',
  wechatNotice_mobile_website: '由于微信限制，手机端支付订单无法在网页端完成支付，请返回手机端继续支付，谢谢！',
  matchHotelMsg: '您对这家酒店感兴趣',
  googlePriceSign: '在谷歌上看到的',
  cityTaxFee: '城市税费用',
  destinationFee: '目的地费用',
  serviceFee: '服务费用',
  cleaningFee: '清洁费用',
  couponUselargeMsg: '您的优惠券已成功使用，此次预订为您节省',
  point: '',
  couponUseshortMsg: '优惠券已使用',
  authorizedLoginTitle: '或通过社交帐号登录',
  Google: 'Google',
  Facebook: 'Facebook',
  Apple: 'Apple',
  remove: '移除',
  mobile: '手机号',
  getMobileCode: '获取验证码',
  mobileTitle: '手机号',
  inputMobileCode: '输入验证码',
  pleaseValidMobileCode: '请输入正确6位数字验证码',
  codeExpire: '验证码已过期',
  timeLimit: '今日次数已用完，请明天再来！',
  CodeError: '验证码错误',
  systemError: '系统错误，请稍后重试',
  sendCodeSuccess: '验证码发送成功',
  countLimit: '今日次数已用完，请明天再来！',
  invalidMobileArea: '暂不支持的区域',
  authorizedRegisterTitle: '或通过社交账户注册',
  authorizedForgetTitle: '如果记住密码比较困难，您可以选择下面的登录方式',
  noLoginNoticeText: '登录后享更低价！',
  mailboxExistsNew: '邮箱地址已注册。',
  oldmobile: '原手机号',
  newmobile: '新手机号',
  buttonBindMobile: '绑定手机号',
  buttonUpdateMobile: '更新手机号',
  administrativeFee: '管理费',
  mobileExists: '手机号已存在',
  coupon: '优惠券',
  noCoupon: '无对应优惠券',
  bindMobileSuccess: '手机号绑定成功',
  oldMobileNotMatch: '原手机号输入错误',
  mobileNumbersCannotBeTheSame: '新老手机号不能相同',
  invalidMobile: '无效的手机号',
  emailLogin: '邮箱登录',
  mobileLogin: '手机登录',
  validDate: '有效期：',
  useNow: '去使用',
  used: '已使用',
  expired: '已过期',
  unUsed: '待使用',
  codeValid: '您的验证码依然有效，无需重新获取。',
  noDestination: '非常抱歉，我们还没有此目的地。',
  interceptingTextTwoCustomerServiceTeam: '客服团队。',
  interceptingTextOne: '抱歉，我们检测到一些异常活动与您的帐户相关。为了保护您的安全，我们暂时限制了您的预定。',
  interceptingTextTwo: '如有疑问，请',
  interceptingTextThree: '感谢您的理解与合作。',
  interceptingTextTwoContactOur: '联系我们',
  BookingId: '预定ID',
  hotelName: '酒店名称',
  checkInDate: '入住日期',
  checkOutDate: '退房日期',
  totalPaymentAmount: '总支付金额',
  ConfirmIng: '确认中',
  paymentConfirmSuccess: '支付确认成功',
  paymentConfirmFail: '支付确认失败',
  paymentConfirmFailNotice: '您的卡或帐户将在10个工作日内收到退款金额。如果您对退款有任何其他疑问，请直接联系您的银行/信用卡发卡机构。如果您有其它任何问题可以随时',
  paymentConfirmSuccessNotice: '您已成功完成支付确认！我们将尽快与酒店确认订单。最终结果将发送至您下单时填写的邮箱（',
  paymentConfirmSuccessNoticeTwo: '）。如有任何疑问，请随时',
  AccountSecurityWarning: '帐号安全预警',
  bookingPendingPaymentSecondConfirm: '为了确保您的交易安全。请前往您的付款邮箱 (',
  bookingPendingPaymentSecondConfirmTwo: ')完成付款确认2小时内未完成确认，订单可能会被取消。',
  RecommendedByNearbyHotels: '附近酒店推荐',
  TransactionFee: '交易费',
  TransactionFeeMsgFirst: '（包含',
  TransactionFeeMsgLast: '交易费）',
  specialCheckInNotice: '特别入住说明',
  refundPolicy: '退款政策',
  includesTaxesFees: '包含税 & 费',
  paymentFailPopUp: '支付失败',
  paymentFailDesc: '支付失败。请核对您的银行卡信息并确保有足够的资金。或者使用其他支付方式。',
  retry: '重试',
  pleaseTickTheCheckbox: '请勾选上面的选框，以表明您已阅读并同意我们的使用条款和隐私政策',
  agreeToRoompai: '我同意Roompai的',
  noAccountMsg: '登录前请先注册账号。',
  lv3Alert: '我们遇到一些技术问题，请稍后再试。',
  lv2RedirectAlert: '为了保证您的账户安全，请绑定手机号码。',
  noneRoomSamePriceMsgLeft: '您选择的房间已售罄。现在',
  noneRoomSamePriceMsgRight: '价格相同。您是否愿意继续预订？',
  noneRoomNonePriceMsgRight: '。您是否愿意继续预订？',
  noneRoomNonePriceMsgCenter: '价格上涨',
  secSpecialRequestsAreGuaranteed: '根据酒店要求，您需要提供到达航班号和起飞航班号信息才可预订。',
  secSpecialRequestsAreGuaranteedAlert: '请输入您的到达航班号和起飞航班号信息。',
  notFoundTitle: '哎呦!',
  notFoundTextOne: '很抱歉，您访问的页面不存在。',
  notFoundTextTwoLeft: '如果您认为这是一个错误，请',
  notFoundTextTwoRight: '，以帮助我们改进服务。',
  continueFinishBook: '未完成的订单',
  间: '间',
  夜: '夜',
  CancelBooking: '取消预订',
  CompleteBooking: '完成预订',
  SystemBusyTryAgain: '我们遇到一些技术问题，请稍后再试。',
  hourCountLimit: '您获取验证码的次数过多，请稍后再试。',
  BindNow: '立即绑定',
  BindLater: '稍后绑定',
  registerNow: '立即注册',
  registerLater: '稍后注册',
  bindMobileTitle: '绑定手机号',
  bindMobileDesc: '绑定手机号，用于订单确认及安全保障。',
  registerMobile: '注册手机号',
  registerDesc: '请注册手机号码。用于订单确认及安全保障。',
  cribFee: '婴儿床费',
  maintenanceFee: '维护费',
  miscellaneousFee: '杂费',
  otherFee: '其他费',
  packageFee: '套餐费',
  petSanitationFee: '宠物卫生费',
  rollawayFee: '加床费',
  roomServiceFee: '客房服务费',
  surcharge: '附加费',
  bindPopNotice: '注意',
  bindPopNoticeLine1: '为保障您的账户安全和预订顺利完成，我们要求您使用真实的手机号进行验证。',
  bindPopNoticeLine2: '请勿使用虚拟手机号（如网络电话、非实名手机号等），这些号码无法通过验证，且我们无法在后续联系到您。',
  bindPopNoticeLine3: '手机号验证是为了确保预订的安全性，并防止潜在的欺诈行为。',
  Country: '国家',
  IAgreeReceiveTextMessage: '我同意接收短信',
  IAgreeWith: '我同意',
  setPassword: '设置密码',
  appleAuthDesc: '正在进行 Apple 授权登录，请注意，后续可能需要您提供手机号码进行校验。',
  appleConfirmCancel: '取消',
  appleConfirmContinue: '继续',
  accountManagement: '帐号管理',
  managementUserAccount: '管理您的帐号数据',
  deleteYouAccount: '永久删除您的Roompai帐户和数据',
  LogoutAccount: '注销帐号',
  logoutAccountConfirm: '确认要注销帐号吗？',
  pleaseNote: '请注意！',
  logoutConfirmText: '注销账号是不可逆的此操作将会影响您在Roompai的数据，我们可能会安全地保留一些信息，例如您的交易记录，以履行法律义务，或在需要建立、行使或捍卫法律权利的情况下。这些信息将被安全地保留，并在不再需要时被删除、匿名化或永久加密留存。',
  emailCancelCode: '我们已向您的注册邮箱发送了一个验证码，请输入验证码完成此操作：',
  mobileCancelCode: '我们已向您的注册手机号发送了一个验证码，请输入验证码完成此操作：',
  logoutAccountSuccess: '帐号注销成功',
  lookingForwardAgain: '期待再次为您服务',
  logoutAccountOrderCheckFail: '您有未处理订单，请处理后再操作。',
  duplicateRegister: '请勿重复注册！',
  emailSubDomainBlocklist: '为确保预订信息准确送达，请勿使用一次性邮箱地址。',
  aboutToFail: '您的预订即将失效！',
  aboutToFailMsg: '我们注意到您正在预订热门酒店，这些房间可能很快售罄！请尽快完成预订以锁定您的房间。',
  later: '稍后',
  bookingNow: '立即预订',
  billingCountryError: '请填写账单国家',
  billingCountry: '账单国家',
  billingAddress: '账单地址',
  billingAddressError: '请填写账单地址',
  billingCity: '账单城市',
  billingCityError: '请填写账单城市',
  billingPostalCode: '账单邮政编码',
  billingPostalCodeError: '请填写账单邮政编码',
  billingProvince: '账单省份',
  cardHolderFirstName: '持卡人名字',
  cardHolderLastName: '持卡人姓氏',
  cardHolderFirstNameError: '请用英文字母输入与您信用卡上所示完全相同的持卡人名字',
  cardHolderLastNameError: '请用英文字母输入与您信用卡上所示完全相同的持卡人姓氏',
  billingapartmentRoom: '公寓，楼层，房间号（可选）',
  billingState: '账单州',
  billingStateError: '请填写账单州',
  mealType: '餐食类型',
  mealAny: '全部',
  mealAllInclusive: '全包',
  mealFullBoard: '全餐(含早/中/晚三餐)',
  mealBedAndBreakfast: '含早',
  mealLunch: '午餐',
  mealDinner: '晚餐',
  mealRoomOnly: '无餐食',
  mealHalfBoard: '半餐(含早/中/晚其中两餐)',
  noMatchingRooms: '未找到匹配的房型'
}
export default zh



// WEBPACK FOOTER //
// ./src/util/zh.js